import React, { useState } from 'react'
import { InfoIcon, Mail, Phone, MapPin, Building, Heart, ChevronDown, Lock, Eye, EyeOff } from 'lucide-react'
import toast from 'react-hot-toast'
import Input from '../../../components/fields/input'
import Textarea from '../../../components/fields/textarea'

export default function AdminProfileView() {
    const [activeTab, setActiveTab] = useState('personal');
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        // Simulate API call
        await new Promise(resolve => setTimeout(resolve, 1000))
        toast.success('Profile updated successfully!')
        setLoading(false)
    }

    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-50 py-6 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
                {/* Profile Header */}
                <div className="mb-4 text-start">
                    <h1 className="mt-4 text-3xl font-bold text-gray-900">Profile Settings</h1>
                    <p className="text-gray-500">Manage your account settings and preferences</p>
                </div>

                {/* Tabs */}
                <div className="mb-6 border-b border-gray-200">
                    <nav className="-mb-px flex space-x-8">
                        <button
                            onClick={() => setActiveTab('personal')}
                            className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'personal'
                                ? 'border-blue-500 text-blue-600'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                        >
                            Personal Information
                        </button>
                        <button
                            onClick={() => setActiveTab('security')}
                            className={`py-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'security'
                                ? 'border-blue-500 text-blue-600'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                        >
                            Security
                        </button>
                    </nav>
                </div>

                {/* Main Content */}
                <div className="bg-white shadow-xl rounded-2xl overflow-hidden">
                    <form onSubmit={handleSubmit} className="p-4 sm:p-6 space-y-6">
                        {activeTab === 'personal' && (
                            <>
                                <div className="grid gap-6 sm:grid-cols-2">
                                    <div className="space-y-2">
                                        <Input
                                            label="Enter your name"
                                            type="text"
                                            name="title"
                                            className="w-full"
                                            placeholder="Enter your name"
                                        // value={formData.title}
                                        // onChange={handleChange}
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <Input
                                            label="Enter your email"
                                            type="email"
                                            name="title"
                                            className="w-full"
                                            placeholder="Enter your email"
                                        // value={formData.title}
                                        // onChange={handleChange}
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <Input
                                            label="Enter your phone number"
                                            type="number"
                                            name="title"
                                            className="w-full"
                                            placeholder="Enter your phone number"
                                        // value={formData.title}
                                        // onChange={handleChange}
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <Input
                                            label="Enter your postal code"
                                            type="number"
                                            name="title"
                                            className="w-full"
                                            placeholder="Enter postal code"
                                        // value={formData.title}
                                        // onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className="grid gap-6 sm:grid-cols-2">
                                    <div className="space-y-2">
                                        <Input
                                            label="Enter your masjid name"
                                            type="text"
                                            name="title"
                                            className="w-full"
                                            placeholder="Enter masjid name"
                                        // value={formData.title}
                                        // onChange={handleChange}
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <Input
                                            label="Enter your position"
                                            type="text"
                                            name="title"
                                            className="w-full"
                                            placeholder="Enter your position"
                                        // value={formData.title}
                                        // onChange={handleChange}
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <Input
                                            label="Enter organization name"
                                            type="text"
                                            name="title"
                                            className="w-full"
                                            placeholder="Enter organization name"
                                        // value={formData.title}
                                        // onChange={handleChange}
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <Input
                                            label="Enter charity number"
                                            type="text"
                                            name="title"
                                            className="w-full"
                                            placeholder="Enter charity number"
                                        // value={formData.title}
                                        // onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className="space-y-2">
                                    <Textarea
                                        id="address"
                                        label="Address"
                                        name="address"
                                        placeholder="Enter your address"
                                    // value={formData.address}
                                    // onChange={handleChange}
                                    // error={errors.address}
                                    />
                                </div>
                            </>
                        )}

                        {activeTab === 'security' && (
                            <div className="space-y-6">
                                <div className="space-y-2">
                                    <label htmlFor="currentPassword" className="text-sm font-medium text-gray-700 flex items-center gap-1">
                                        Current Password
                                    </label>
                                    <div className="relative">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            id="currentPassword"
                                            className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-1 focus:ring-blue-500 focus:border-transparent transition-shadow focus:outline-none"
                                            placeholder="Enter current password"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                            className="absolute right-3 top-1/2 -translate-y-1/2"
                                        >
                                            {showPassword ? (
                                                <EyeOff className="w-5 h-5 text-gray-400" />
                                            ) : (
                                                <Eye className="w-5 h-5 text-gray-400" />
                                            )}
                                        </button>
                                    </div>
                                </div>

                                <div className="space-y-2">
                                    <label htmlFor="newPassword" className="text-sm font-medium text-gray-700">New Password</label>
                                    <div className="relative">
                                        <input
                                            type={showNewPassword ? "text" : "password"}
                                            id="newPassword"
                                            className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-1 focus:ring-blue-500 focus:border-transparent transition-shadow focus:outline-none"
                                            placeholder="Enter new password"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowNewPassword(!showNewPassword)}
                                            className="absolute right-3 top-1/2 -translate-y-1/2"
                                        >
                                            {showNewPassword ? (
                                                <EyeOff className="w-5 h-5 text-gray-400" />
                                            ) : (
                                                <Eye className="w-5 h-5 text-gray-400" />
                                            )}
                                        </button>
                                    </div>
                                </div>

                                <div className="space-y-2">
                                    <label htmlFor="confirmPassword" className="text-sm font-medium text-gray-700">Confirm New Password</label>
                                    <div className="relative">
                                        <input
                                            type={showConfirmPassword ? "text" : "password"}
                                            id="confirmPassword"
                                            className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-1 focus:ring-blue-500 focus:border-transparent transition-shadow focus:outline-none"
                                            placeholder="Confirm new password"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            className="absolute right-3 top-1/2 -translate-y-1/2"
                                        >
                                            {showConfirmPassword ? (
                                                <EyeOff className="w-5 h-5 text-gray-400" />
                                            ) : (
                                                <Eye className="w-5 h-5 text-gray-400" />
                                            )}
                                        </button>
                                    </div>
                                </div>

                                <div className="bg-yellow-50 p-4 rounded-lg">
                                    <p className="text-sm text-yellow-700">
                                        Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one special character.
                                    </p>
                                </div>
                            </div>
                        )}

                        <div className="flex justify-end space-x-4 pt-6 border-t">
                            <button
                                type="button"
                                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={loading}
                                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {loading ? 'Saving...' : 'Save Changes'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}